module.exports = __webpack_public_path__ + "static/media/field-hockey.3d5c20ee.svg";